import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.autovexlight": ["Autovex lyst ikon"] }, "en": { "icon.title.autovexlight": ["AutovexLight logo"] }, "fi": { "icon.title.autovexlight": ["Autovex vaalea logo"] }, "da": { "icon.title.autovexlight": ["Autovex lyst ikon"] }, "sv": { "icon.title.autovexlight": ["AutovexLight-logga"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconAutovexLight42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `AutovexLight logo`, id: "icon.title.autovexlight", comment: "Title for AutovexLight icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path fill="#0B6DFF" d="M31.303 1H10.456A2.456 2.456 0 0 0 8 3.456v20.847c0 1.357 1.1 2.456 2.456 2.456h20.848c1.356 0 2.455-1.1 2.455-2.456V3.456A2.455 2.455 0 0 0 31.303 1"></path><path fill="#fff" d="m24.322 11.737-.569 3.326h-.001v.002h-.01l-.547-3.328h-.989l.84 4.218h1.396l.828-4.218zm-13.854 4.241h.96l.092-.558h.945l.092.558h.99l-.844-4.24H11.3zm1.193-1.362.332-1.964h.012l.325 1.964zm3.2 1.38c.304 0 .558-.097.758-.308h.017v.267h.825v-3.28h-.96v2.016c0 .261-.143.418-.377.418-.233 0-.359-.157-.359-.418v-2.016h-.937v2.248c0 .66.387 1.078 1.023 1.078m3.24.007c.206 0 .394-.03.558-.08v-.895a.8.8 0 0 1-.334.08c-.148 0-.247-.067-.247-.265V13.5h.603v-.826h-.603v-.647h-.66l-.018.158c-.047.43-.212.624-.572.745v.57h.313v1.514c0 .696.32.993.945.993m2.532 0c1 0 1.666-.672 1.666-1.683s-.666-1.684-1.666-1.684-1.671.678-1.671 1.684.666 1.684 1.671 1.684Zm-.702-1.683c0-.46.285-.77.703-.77.417 0 .696.31.696.77s-.285.769-.697.769c-.411 0-.702-.315-.702-.77Zm7.058 1.673c.34 0 .721-.06 1.036-.206v-.926c-.285.2-.648.29-.981.29-.436 0-.77-.163-.884-.538h2.12c.224-1.272-.424-1.975-1.448-1.975s-1.654.654-1.654 1.684.667 1.671 1.811 1.671m-.819-2.073c.097-.303.321-.49.648-.49s.57.17.612.49zm2.261 2.054h.988l.401-1.072h.012l.408 1.072h1.055l-.768-1.67.774-1.633h-.974l-.404 1.004h-.012l-.41-1.004h-1.07l.774 1.584z"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-autovex-light-42")) {
  customElements.define("fp-icon-autovex-light-42", IconAutovexLight42);
}
export {
  IconAutovexLight42
};
